import { Component } from 'react'
import { withRouter } from 'react-router-dom'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname.match(/results/) && this.props.location.pathname.match(/results/)) return
    if (this.props.location.pathname === prevProps.location.pathname) return

    window.scrollTo(0, 0)

    const el = window.parent.document.getElementById('child-affordability')
    if (!el) return

    el.scrollIntoView()
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)
